import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Config from '../../../config';
import LocalstorageService from '../../../utils/LocalStorageService';

const LoadingIndicator = () => {
  const [showEscape, setShowEscape] = useState(false);

  useEffect(() => {
    const showAfterMs = 15000;
    const timeout = setTimeout(() => {
      setShowEscape(true);
    }, showAfterMs);

    return () => {
      clearTimeout(timeout);
    };
  });

  const escapeFunction = () => {
    LocalstorageService.clearReduxLocalStorage();
    window.location.reload(true);
  };

  const renderEscapeButton = () => {
    return (
      <Button type="button" onClick={escapeFunction}>
        {Config.TextStrings.stuckedButton}
      </Button>
    );
  };

  return (
    <LoadingWrapper>
      <Loader>
        <img src={Config.ImageAssets.spinner} alt="loading" />
      </Loader>
      {showEscape && renderEscapeButton()}
    </LoadingWrapper>
  );
};

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  width: 100%;
`;

const Loader = styled.div`
  display: flex;
  justify-content: center;

  img {
    width: 64px;
  }
`;

const Button = styled.button`
  background-color: transparent;
  border: none;
  color: ${Config.Color.coolBlueDark};

  &:hover,
  &:active {
    color: ${Config.Color.coolBlue};
  }
`;

export default LoadingIndicator;
